import {useEffect, useState} from "react";
import {toast} from "react-toastify";
import { CashOpeningBalancesDto } from "../dtos/CashOpeningBalancesDto";
import { CashOpeningBalancesModel } from "../models/CashOpeningBalancesModel";
import { CashOpeningBalancesService } from "src/services/documents/CashOpeningBalancesService";
import { AppEntities } from "src/config/entities";
import { CashOpeningBalancesLineDto } from "../dtos/CashOpeningBalancesLineDto";

interface IProps {
    documentId?: string;
}

export const useFetchCashOpeningBalances = ({documentId}: IProps) => {
    const [isDocumentLoading, setIsDocumentLoading] = useState(false);
    const [documentDto, setDocumentDto] = useState<CashOpeningBalancesDto | null>(null);
    const [documentModel, setDocumentModel] = useState<CashOpeningBalancesModel | null>(null);
    const dataService = AppEntities.CashOpeningBalances.getDataService() as CashOpeningBalancesService;

    const postDocument = async () => {
        if (!documentId) return;
        await dataService.PostDocument(documentId);
        toast.success("Document posted successfully");
    }

    const cancelDocument = async () => {
        if (!documentId) return;
        await dataService.CancelDocument(documentId);
        toast.success("Document canceled successfully");
    }
    
    const updateDocument = async (documentModel: CashOpeningBalancesModel) => {
        if (!documentId) return;
        console.log(documentModel)
        const requestDto: CashOpeningBalancesDto = {...documentModel};
        const responseDto = await dataService.Update(requestDto);
        setDocumentDto(responseDto);
        // toast.success("Document updated successfully");
    }

    const fetchDocument = async () => {
        try {
            setIsDocumentLoading(true);

            console.log("documentId", documentId);

            let responseDto: CashOpeningBalancesDto | null = null;
            let responseLines:CashOpeningBalancesLineDto[] = [];

            if (!documentId) {
                responseDto = await dataService.Create({
                    documentDate: new Date(),
                });
                setDocumentDto(responseDto);
            } else {
                responseDto = await dataService.Get(documentId);
                setDocumentDto(responseDto);
            }
            
            if (!responseDto) return;
            
            const newModel: CashOpeningBalancesModel = {
                ...responseDto,
                  lines: [...responseLines],
            };
            setDocumentModel(newModel);
        } catch (e) {
            console.log(e);
        } finally {
            setIsDocumentLoading(false);
        }
    }

    useEffect(() => {
        fetchDocument();
    }, [documentId]);

    return {
        isDocumentLoading,
        documentDto,
        documentModel,
        postDocument,
        cancelDocument,
        updateDocument
    }
}